import React, { useCallback } from "react";
import PropTypes from "prop-types";
import SelectDateUserDaysOff from "~/components/SelectDate/SelectDateUserDaysOff.jsx";
import Angie from "~/utils/angie.jsx";
import { TaskRescheduleAction } from "../../actions/TaskRescheduleAction";

export const SelectTaskDate = ({ id, onChange, assigneeId, ...rest }) => {
  const handleSave = useCallback(
    (value) => {
      const dates = value ? value : { from: null, to: null };
      typeof onChange === "function" && onChange({ dates });
    },
    [onChange]
  );

  const onDayClick = useCallback((_, modifiers) => {
    if (modifiers["c-DayPicker-Day--disabled"]) {
      Angie.logger.info("Unavailable day clicked", {
        clicked_from: "due_date",
        disabled_day_type: modifiers["c-DayPicker-Day--weekend"]
          ? "weekend"
          : modifiers["c-DayPicker-Day--nonWorkingDay"]
          ? "non-working-day"
          : "disabled",
      });
    }
  }, []);

  return (
    <TaskRescheduleAction
      id={id}
      action="onSave"
    >
      <SelectDateUserDaysOff
        {...rest}
        userId={assigneeId}
        onSave={handleSave}
        onDayClick={onDayClick}
      />
    </TaskRescheduleAction>
  );
};

SelectTaskDate.propTypes = {
  id: PropTypes.number,
  onChange: PropTypes.func,
  assigneeId: PropTypes.number,
};

SelectTaskDate.defaultProps = {
  assigneeId: 0,
};
